"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoader = exports.Loader = void 0;
var tslib_1 = require("tslib");
var useLoader_1 = require("@reactionable/core/lib/ui/loader/useLoader");
var react_1 = tslib_1.__importDefault(require("react"));
var Spinner_1 = tslib_1.__importDefault(require("react-bootstrap/Spinner"));
var react_i18next_1 = require("react-i18next");
exports.Loader = function (_a) {
    var _b = _a.overlay, overlay = _b === void 0 ? true : _b;
    var t = react_i18next_1.useTranslation().t;
    var spinnerElement = (react_1.default.createElement(Spinner_1.default, { animation: "grow", role: "status", variant: "primary" },
        react_1.default.createElement("span", { className: "sr-only" }, t('Loading'))));
    if (!overlay) {
        return spinnerElement;
    }
    return (react_1.default.createElement("div", { className: "spinner--overlay", style: {
            width: '100%',
            height: '100%',
            position: 'fixed',
            top: '50%',
            left: '50%',
        } }, spinnerElement));
};
exports.useLoader = function (props) {
    if (props === void 0) { props = {}; }
    return useLoader_1.useLoader(tslib_1.__assign(tslib_1.__assign({}, props), { Component: exports.Loader }));
};
//# sourceMappingURL=Loader.js.map